import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '../components';
import { IdentityContext, IdentityProvider } from '../context';
import { useIndex } from '../hooks';

import { LifeDocumentIntroHeader, LifeDocumentIntroSection } from './will-page';

const sections = [
  {
    icon: 'alarm',
    title: 'Time Required',
    content: '15 minutes',
    subText: 'You can save your progress and return later.'
  },
  {
    icon: 'format_list_numbered',
    title: 'Steps',
    content: '6',
    subText: 'Simple guided steps'
  }
];

export default function FuneralArrangementsPage() {
  console.log('funeral arrangements page');

  return (
    <IdentityProvider>
      <FuneralArrangementsPageContent />
    </IdentityProvider>
  );
}

export function FuneralArrangementsPageContent() {
  const navigate = useNavigate();
  const { person } = useContext(IdentityContext);
  console.log('funeral arrangements component', person);
  const { data, loading } = useIndex('funeral_arrangements', { person_id: person?.id });

  const funeralArrangement = data && data[0];

  useEffect(() => {
    if (funeralArrangement && funeralArrangement.status === 'draft') {
      navigate('/people/self/life-documents/funeral-arrangements/new/continue', { replace: true });
    }
  }, [ navigate, funeralArrangement ]);

  if (loading) {
    return <div>Loading funeral arrangement...</div>;
  }
  
  return (
    <div className="funeral-arrangements-page">
      <LifeDocumentIntroHeader
        icon="description"
        title="Welcome to the funeral arrangements process"
        description="This guided process will help you create a funeral arrangement in just a few simple steps."
      />
      <div className="life-document-intro-sections">
        {
          sections.map((section, index) => (
            <LifeDocumentIntroSection
              key={index}
              icon={section.icon}
              title={section.title}
              content={section.content}
              subText={section.subText}
            />
          ))
        }
      </div>
      {/* TODO: bigger buttons */}
      <div className="button-container" style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Link to="new">
          <Button>Select Arrangements</Button>
        </Link>
      </div>
    </div>
  );
}

